export default __webpack_public_path__ + "static/screeny-130-gpz-tens-to-1-b7325b244a109a8cdbca48819ae3256b.jpg";